import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { useMst } from '../../model/Root';
import { useTranslation } from 'react-i18next';
import Layout from '../../components/Layout';
import AddButton from '../../components/Button/AddButton';
import Table from '../../components/Table/Table';
import { COLLECTION_PAGE_TABLE } from '../../utils/constants';
import { Row, LinkRow } from '../../types';

const CollectionScreen = observer(() => {
  const { t } = useTranslation();
  const {
    collectionPageStore: { pages, getPages },
  } = useMst();
  const [selectedRow, setSelectedRow] = useState<Row | LinkRow>();
  const [result, setResult] = useState<Row[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPages = async () => {
      await getPages();
      const tempResult: Row[] =
        pages.length > 0
          ? pages.map((page) => ({
              id: page.id,
              name: page.name,
              value: page.name,
            }))
          : [];

      setResult(tempResult);
    };
    fetchPages();
  }, [getPages, pages]);

  useEffect(() => {
    if (!selectedRow?.id) return;
    navigate(`/collection/${selectedRow.id}`);
  }, [selectedRow?.id, navigate]);

  return (
    <Layout title={t('collection_page')}>
      <AddButton onClick={() => navigate('/collection/create')} text={t('add_new')} />
      <Table
        data={result.length > 0 ? result : []}
        tableType={COLLECTION_PAGE_TABLE}
        selectedRow={selectedRow}
        setSelectedRow={(value) => setSelectedRow({ id: value?.id, value: value?.value })}
      />
    </Layout>
  );
});

export default CollectionScreen;
